module.exports = __webpack_public_path__ + "img/HZGB03-01-02_2.1e9111a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB03-01-02_2.png
// module id = x+i7
// module chunks = 0